// lottieCache.js - loads character/prop animation files (Lottie JSON) once per page.
//
// The same character file is often used on many slides. Before, it was downloaded again for
// every layer, one after another. Now each file is downloaded once (also when several layers ask
// for it at the same time), and each caller gets its own copy, because the editor changes the
// JSON (skin colour, talking mouth, ...).

const cache = new Map(); // full URL -> Promise<object>

function copy(json) {
  if (typeof structuredClone === "function") return structuredClone(json);
  return JSON.parse(JSON.stringify(json));
}

export function lottieUrl(apiBaseURL, filePath) {
  if (!filePath) return null;
  if (/^https?:\/\//i.test(filePath)) return filePath;
  return String(apiBaseURL).replace(/\/$/, "") + "/" + String(filePath).replace(/^\//, "");
}

/** Resolves to a private copy of the animation JSON. Rejects if it cannot be loaded. */
export function loadLottieJson(apiBaseURL, filePath) {
  const url = lottieUrl(apiBaseURL, filePath);
  if (!url) return Promise.reject(new Error("No animation file path"));

  let pending = cache.get(url);
  if (!pending) {
    pending = fetch(url).then((resp) => {
      if (!resp.ok) throw new Error(`HTTP ${resp.status} for ${url}`);
      return resp.json();
    });
    // A failed download is not cached, so it is tried again next time.
    pending.catch(() => cache.delete(url));
    cache.set(url, pending);
  }
  return pending.then(copy);
}
